import { render } from "./Embed.vue?vue&type=template&id=24c8362f&ts=true"
import script from "./Embed.vue?vue&type=script&lang=ts"
export * from "./Embed.vue?vue&type=script&lang=ts"

import "./Embed.vue?vue&type=style&index=0&id=24c8362f&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__